/**
 * MIT License
 *
 * Copyright (c) 2025 Chris M. Perez
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Config, Effect } from 'effect';

export const RouterConfig = {
	base: Config.string('ROUTER_BASE').pipe(Config.withDefault('')),
	historyMode: Config.literal(
		'web',
		'hash'
	)('ROUTER_HISTORY_MODE').pipe(Config.withDefault('web' as const)),
	scrollToTop: Config.boolean('ROUTER_SCROLL_TO_TOP').pipe(
		Config.withDefault(true)
	),
};

export type RouterConfigType = {
	base: string;
	historyMode: 'web' | 'hash';
	scrollToTop: boolean;
};

export const loadRouterConfig = Effect.all({
	base: RouterConfig.base,
	historyMode: RouterConfig.historyMode,
	scrollToTop: RouterConfig.scrollToTop,
});
